import React from 'react';
import CtTermsTable from './table/CtTermsTable';

const TermsContent: React.FC = () => {
  return <CtTermsTable />;
};

export default TermsContent;
